import { useContext } from 'react';
import { BasicSanitationChartsDataContext } from '../contexts/BasicSanitationChartsDataContext';

export const useBasicSanitationChartsDataContext = () => {
    return useContext(BasicSanitationChartsDataContext);
};
